import { RiContactsBook2Line } from "react-icons/ri";
//import { FiSettings } from "react-icons/fi";
import { TiHomeOutline, TiContacts } from "react-icons/ti";
import { /*AiFillSetting,*/ AiOutlineTeam } from "react-icons/ai";

const NavItemsData = [
  {
    name: "Home",
    HashLink: "home",
    link: "/",
    islink: false,
    icon: TiHomeOutline,
  },
  {
    name: "Services",
    HashLink: "services",
    link: "/services",
    islink: false,
    icon: TiContacts,
  },
  // {
  //   name: "Training",
  //   HashLink: "training",
  //   link: "/training",
  //   icon: FiSettings,
  //   islink: true
  // },
  {
    name: "Teams",
    HashLink: "team",
    link: "/teams",
    islink: false,
    icon: AiOutlineTeam,
  },
  {
    name: "Contact",
    HashLink: "contact",
    link: "/contacts",
    icon: RiContactsBook2Line,
    islink: false,
  },
];

export { NavItemsData };
